export enum Manufacturer {
  Apple = 'Apple',
  BlackBerry = 'BlackBerry',
  Google = 'Google',
  Other = 'Other',
  Samsung = 'Samsung',
}
